// Tax and 1099 tab (slice E: sales tax by state, vendors and 1099). Stub from LP-309 S0; slice E owns this file.
// BooksPage lists the tab only once this file exports enabled = true; it receives
// { me, accounts, deals, reloadShared, onGo } like every Books tab.

export const enabled = false;

export default function TaxTab() {
  return null;
}
